// Organizations
export const availableOrganizations = /* GraphQL */ `
  query (
    $first: Int
    $after: String
    $order: [OrganizationSortInput!]
    $where: OrganizationFilterInput
  ) {
    availableOrganizations(first: $first, after: $after, order: $order, where: $where) {
      totalCount
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      edges {
        cursor
        node {
          displayName
          enabled
          id
          isPending
          role
          type
          details {
            createdOn
            id
            organizationId
          }
        }
      }
    }
  }
`;

export const getOrganization = /* GraphQL */ `
  query($id: Int!) {
    getOrganization(id: $id) {
      displayName
      enabled
      id
      isPending
      role
      type
      details {
        createdOn
        id
        organizationId
      }
    }
  }
`;
